import { Component, OnInit } from '@angular/core';
import { ChartType } from 'chart.js';
//import { MultiDataSet } from 'ng2-charts';
import { ChartDataSets , RadialChartOptions } from 'chart.js';
//import { SingleDataSet, Label, monkeyPatchChartJsLegend, monkeyPatchChartJsTooltip } from 'ng2-charts';
import {  ChartOptions } from 'chart.js';
//import { Color} from 'ng2-charts';
import {MychampService} from '../services/mychamp.service'
import {MasterService} from '../services/master.service'
import {NgbModal, ModalDismissReasons, NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-assesment',
  templateUrl: './assesment.component.html',
  styleUrls: ['./assesment.component.css'],
  providers:[MychampService,MasterService]
})
export class AssesmentComponent implements OnInit {

  feedtls:any[];
  feedet:any[];


  barChartOptions: ChartOptions = {
    responsive: true,
  };
  barChartLabels: any = [];
  barChartType: ChartType = 'bar';
  barChartLegend = true;
  barChartPlugins = [];
  barChartColors: any= [
    {
      
      backgroundColor: '#FF00CC',
    },
    {
     
      backgroundColor: '#0033FF',
    },
  ];
  barChartData: ChartDataSets[] = [
    // { data: [45, 37, 60, 70, 46, 33], label: 'Best Fruits' }
  ];

  assdetchartdata: ChartDataSets[] = [
    // { data: [45, 37, 60, 70, 46, 33], label: 'Best Fruits' }
  ];

  constructor(private mservice: MychampService,private msservice: MasterService,private modalService: NgbModal) {
  //  this.getpayip(); 
  }

  ngOnInit(): void {
  this.getreporthead();
  }


  getreporthead() {
    //var pstdata={jpid:jid,oprtype:oprtype};
    this.mservice.getreporthead()
        .subscribe( 
        resultArray => {
            console.log('assignments', resultArray);
           this.feedtls=resultArray.Resreportcard;
           this.composecharth(resultArray.Resreportcard);
          
        },
        error => console.log("Error :: " + error)
        )
  }

  getreportdet(asid) {
    //var pstdata={jpid:jid,oprtype:oprtype};
    this.mservice.getreportdet(asid)
        .subscribe( 
        resultArray => {
            console.log('assignments', resultArray);
           this.feedet=resultArray.Resreportcard;
           this.composecharth(resultArray.Resreportcard);
          
        },
        error => console.log("Error :: " + error)
        )
  }

  composecharth(arrdata)
{
  
 
  
    //this.clsdate=resultArray;
    var arr = [];
    var issued = [];
   // var returned = [];
    for ( var i = 0; i < arrdata.length ; i++) {
      //console.log('multiarray -i',JSON.stringify(i));
       
            
            arr.push(arrdata[i].Aname);
            issued.push(parseInt( arrdata[i].Per)); // 
         //   returned.push(parseInt( resultArray[i].returned));
            
           
    }
   
   this.barChartData = [
      { data: issued, label: 'Scored', 
     }
      
    ];
     this.barChartLabels = arr;
  
   
    console.log(this.barChartData);
    
   // this.dataSource = new MatTableDataSource(resultArray);
   
}


}
